module.exports = __webpack_public_path__ + "img/2.7fda1e5c.jpg";